import { Api } from '../AApi'

export const API_BACKUP = new Api(
  {
    url: 'backup',
    isConvertFormData: true,
    only: ['list', 'destroy'],
  },
  {
    backup: {
      async request() {
        return this.sdk.request({
          method: 'post',
          url: `backup`,
        })
      },
    },
    download: {
      async request(id) {
        return this.sdk
          .request({
            method: 'get',
            url: `download-backup/${id}`,
            responseType: 'blob',
          })
          .then((res) => res.data)
      },
    },
    restore: {
      async request(data) {
        return this.sdk
          .request({
            method: 'post',
            url: `restore`,
            data,
          })
          .then((res) => res.data)
      },
    },
  }
)
